'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var smallDevice = exports.smallDevice = '@media (max-width: 769px)';
var largeDevice = exports.largeDevice = '@media (min-width: 770px)';